import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * TwoFactorAuthGuard
 * 
 * Ensure a user passes two factor authentication before accessing the app. They pass by entering the correct
 * code provided via email
 */
export default async (to: Route, from: Route, next: NavigationGuardNext) => {
    //  Create a pass function
    const pass = () => {
        store.getters.appDebug && console.log(`GUARD: 2FA-auth-guard pass...`)
        return next()
    }

    //  Create a fail function
    const fail = (path: string) => {
        store.getters.appDebug && console.log('GUARD: 2FA-auth-guard stop.')
        return next(path)
    }

    //  Fetch the current user
    const user = store.getters.user

    //  If the user doesn't exist route to home page
    if (!user) {
        //  Get deep link params (if valid) for redirecting after signin
        const params = getDeepLinkParams(to)

        //  Redirect to signin
        return fail(`/signin${params}`)
    }

    //  Grab the user auth token as they need to have passed username / password auth first 
    const userToken = localStorage.getItem('token')

    //  If this guard somehow got called without the user signing in i.e no token then return them to sign in page
    if (!userToken) return fail('/signin')

    //  Else check to see if they have their two factor token 
    const twoFactorToken = localStorage.getItem('two_factor_token')

    //  If they have no token they fail auth and return them to the two factor auth workflow
    if (!twoFactorToken) return fail('/signin/2fa')

    //  If they do have the two factor token set, verify with the backend that this token is correct and not manually added
    //  if the token is incorrect we return them to sign-in, this is to prevent hackers from trying to manually add the 2fa token to local storage
    //  and we return a 500 and 401 if this occurs so we send them back to sign-in as all tokens are deleted in this case
    if (twoFactorToken) {
        //  Must pass the userToken here with the twoFactorToken or the authUserTokenSet will unset the token causing the user to not be able to access the app
        const response = await store.dispatch('authUserGet', {'userToken': userToken, 'twoFactorToken': twoFactorToken}) 

        if (!response) return fail('/signin')
    }

    //  Else, guard passes, continue
    return pass()
}